'use strict';
import * as $j_app$002edata$002e$002dPayment$002dDetails$0024$002dUnited$002dKingdom from "./app.data.-Payment-Details$-United-Kingdom.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_PaymentDetails$UnitedKingdom$() {
}
export { $c_Lapp_data_PaymentDetails$UnitedKingdom$ as $c_Lapp_data_PaymentDetails$UnitedKingdom$ };
$p = $c_Lapp_data_PaymentDetails$UnitedKingdom$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_PaymentDetails$UnitedKingdom$;
/** @constructor */
function $h_Lapp_data_PaymentDetails$UnitedKingdom$() {
}
export { $h_Lapp_data_PaymentDetails$UnitedKingdom$ as $h_Lapp_data_PaymentDetails$UnitedKingdom$ };
$h_Lapp_data_PaymentDetails$UnitedKingdom$.prototype = $p;
$p.n = (function() {
  return "UnitedKingdom";
});
$p.bKU = (function(x$0) {
  return new $j_app$002edata$002e$002dPayment$002dDetails$0024$002dUnited$002dKingdom.$c_Lapp_data_PaymentDetails$UnitedKingdom(x$0.e(0), x$0.e(1));
});
$p.U = (function(p) {
  return this.bKU(p);
});
var $d_Lapp_data_PaymentDetails$UnitedKingdom$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PaymentDetails$UnitedKingdom$, "app.data.PaymentDetails$UnitedKingdom$", ({
  EB: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_PaymentDetails$UnitedKingdom$ as $d_Lapp_data_PaymentDetails$UnitedKingdom$ };
var $n_Lapp_data_PaymentDetails$UnitedKingdom$;
function $m_Lapp_data_PaymentDetails$UnitedKingdom$() {
  if ((!$n_Lapp_data_PaymentDetails$UnitedKingdom$)) {
    $n_Lapp_data_PaymentDetails$UnitedKingdom$ = new $c_Lapp_data_PaymentDetails$UnitedKingdom$();
  }
  return $n_Lapp_data_PaymentDetails$UnitedKingdom$;
}
export { $m_Lapp_data_PaymentDetails$UnitedKingdom$ as $m_Lapp_data_PaymentDetails$UnitedKingdom$ };
//# sourceMappingURL=app.data.-Payment-Details$-United-Kingdom$.js.map
